    export const cardInfo = {
      eng: [
      {
        name: "MAGIC package (200 channels)",
        programs: []
      },
      {
        name: "PASSION package (180 channels)",
        programs: []
      },
      {
        name: "CANAL+ package (14 channels)",
        programs: []
      },
      {
        name: "CHARME package (4 channels)",
        programs: []
      }
      ], 
      fra: [
    {
        name: "Bouquet MAGIC (200 chaînes)",
        programs: []
      },
      {
        name: "Bouquet PASSION (180 chaînes)",
        programs: []
      },{
        name: "Bouquet CANAL+ (14 chaînes)",
        programs: []
      },
      {
        name: "Bouquet CHARME (4 chaînes)",
        programs: []
      }
      ]
    };